import { Variants } from './Banner';

type BannerContent = Record<
    Variants,
    {
        title: string;
        content: string;
        button: string;
        path: string;
    }
>;

export const bannerData: BannerContent = {
    generic: {
        title: 'Get the most from Zoopla',
        content:
            'Track the value of your home over time and compare it to others in the area to help you figure out the best time to move.',
        button: 'Find and track your home',
        path: '/my-home/'
    },
    homeowner_not_claimed: {
        title: 'Think you know how much your home is worth?',
        content:
            'We know a great way to find out...it’s called My Home and it’s all about, well, your home.',
        button: 'Find and track your home',
        path: '/my-home/'
    },
    homeowner: {
        title: 'The latest estimate for your home',
        // placeholder when estimate value not present
        content:
            'Learn even more about the estimate by checking how it compares to last month and the rest of the local market.',
        button: 'Discover the details',
        path: '/myaccount/my-home/'
    },
    seller_not_claimed: {
        title: 'Look good in front of the estate agent',
        content:
            'Find out what your home’s worth and what the local competition is up to before you get an agent valuation.',
        button: 'Get my home estimate',
        path: '/my-home/'
    },
    seller: {
        title: 'Moving? There’s an agent for that',
        // placeholder when estimate value not present
        content: 'Get the most accurate valuation from an agent (or three).',
        button: 'Arrange an in-person valuation',
        path: '/valuation/'
    },
    first_time_buyer: {
        title: 'Your first step onto the property ladder',
        content:
            'Buying your first home but need to decide on where? We can help with making that big decision.',
        button: 'How to check out an area',
        path: '/discover/buying/how-to-check-out-the-area-you-want-to-move-to/'
    },
    renter: {
        title: 'Are you paying over the odds on rent?',
        content:
            'Let’s answer your questions about the rental market and how you can cope with rising rents and living costs.',
        button: 'What does it mean for me?',
        path: '/discover/renting/whats-happening-with-rents-and-what-does-it-mean-for-you/'
    },
    no_your_situation: {
        title: 'Customise your experience',
        content:
            'Share some details and we’ll show more of what you need and less of what you don’t.',
        button: 'Add my situation',
        path: '/myaccount/my-situation/'
    }
};
